import React from "react";
import styles from "./EventMetrics.module.scss";

interface IProps {
  dogs: number;
  entries: number;
  distinctBreeds: number;
}

const EventMetrics: React.FC<IProps> = ({ dogs, entries, distinctBreeds }) => {
  return (
    <div className={styles.EventMetrics}>
      <div className={styles.metricCard}>
        <div className={styles.num}>{dogs}</div>
        <div className={styles.label}>Dogs</div>
      </div>
      <div className={styles.metricCard}>
        <div className={styles.num}>{entries}</div>
        <div className={styles.label}>Entries</div>
      </div>
      <div className={styles.metricCard}>
        <div className={styles.num}>{distinctBreeds}</div>
        <div className={styles.label}>Distinct Breeds</div>
      </div>
    </div>
  );
};

export default EventMetrics;

